export default "__VITE_ASSET__87e5c675__"